import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=a40fb1de&scoped=true&"
import script from "./BankAccounts.vue?vue&type=script&lang=js&"
export * from "./BankAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BankAccounts.vue?vue&type=style&index=0&id=a40fb1de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40fb1de",
  null
  
)

export default component.exports